// src/components/Navbar.js
import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../redux/actions/authActions';
import { setSelectedUser } from '../redux/actions/userActions';
import logo from '../assets/logos/PRV-Website-Logo-Original.webp';

function AppNavbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, permissions } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login/email');
  };

  const handleChangePassword = () => {
    // Set the currently logged-in user as the selected user
    dispatch(setSelectedUser(user));
    navigate('/password-change');
  };

  return (
    <Navbar bg="light" variant="light" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            alt="PRV audio"
            src={logo}
            width="40%"
            height="40%"
            className="d-inline-block align-top"
          />{' '}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {(permissions && permissions.includes('shipping')) && (
              <Nav.Link as={Link} to="/shipping">
                Shipping
              </Nav.Link>
            )}
            {permissions &&
              (permissions.includes('admin') || permissions.includes('superuser')) && (
                <NavDropdown title="Admin" id="admin-dropdown">
                  <NavDropdown.Item as={Link} to="/users">
                    Users
                  </NavDropdown.Item>
                  {permissions.includes('superuser') && (
                    <NavDropdown.Item as={Link} to="/logs">
                      Logs
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
          </Nav>
          <Nav>
            <Nav.Link onClick={handleChangePassword}>
              Change My Password
            </Nav.Link>
            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
